import { render, staticRenderFns } from "./ContratEdit.vue?vue&type=template&id=0ca5b597&"
import script from "./ContratEdit.vue?vue&type=script&lang=js&"
export * from "./ContratEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports